import _ from 'lodash';

import EventEmitter from 'js/vendor/EventEmitter';

import SettingsDispatcher from 'bundles/account-settings/SettingsDispatcher';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import type { ProfileSetting } from 'bundles/account-settings/constants/SettingsConstants';

const { Fields, Actions, UpdateStates, TwoFactorAuthenticationStatus } = SettingsConstants;

const DEFAULT_LOCALE = 'en_US';

type Status = {
  state: (typeof SettingsConstants)['UpdateStates'][keyof (typeof SettingsConstants)['UpdateStates']];
};

let _user: $TSFixMe = null;
let _topSection: $TSFixMe = null;
let _notificationPreferences: $TSFixMe = null;
let _creditCardPreferences: $TSFixMe = null;
let _wallets: $TSFixMe = null;
let _showDeleteCreditCardModal = false;
let _activeWalletId: $TSFixMe = null;
let _emailPreferences: $TSFixMe = null;
let _invalidFields: $TSFixMe = null;
let _updatedEmailAddress: $TSFixMe = null;
let _unsubscribedAllEmails: $TSFixMe = null;
const _partnerBannerStatus = {};
let _updateStatus: Status = {
  state: UpdateStates.IDLE,
};
const _pendingChanges = {};

let _twoFactorAuthenticationStatus: (typeof SettingsConstants)['TwoFactorAuthenticationStatus'][keyof (typeof SettingsConstants)['TwoFactorAuthenticationStatus']] =
  TwoFactorAuthenticationStatus.UNAVAILABLE;
let _twoFactorAuthenticationInvalidFields: (typeof SettingsConstants)['Fields'][keyof (typeof SettingsConstants)['Fields']][] =
  [];
let _twoFactorAuthenticationQRCode: $TSFixMe = null;
let _twoFactorAuthenticationUpdating = false;
let _twoFactorAuthenticationSuccess = false;
let _isAccountDeleted = false;

const SettingsStore = _.extend({}, EventEmitter.prototype, {
  getTopSection() {
    return _topSection;
  },

  getUser() {
    return _user;
  },

  getUserId() {
    return _user[Fields.ID];
  },

  getFullName() {
    return _user[Fields.FULL_NAME];
  },

  getEmailAddress() {
    return _user[Fields.EMAIL_ADDRESS];
  },

  getLocale() {
    return _user[Fields.LOCALE] || DEFAULT_LOCALE;
  },

  getTimezone() {
    return _user[Fields.TIMEZONE];
  },

  getUpdateStatus() {
    return _updateStatus;
  },

  getInvalidFields() {
    return _invalidFields;
  },

  getUpdatedEmailAddress() {
    return _updatedEmailAddress;
  },

  getNotificationPreferences() {
    return _notificationPreferences;
  },

  getCreditCardPreferences() {
    return _creditCardPreferences;
  },

  getPaymentWallets() {
    return _wallets;
  },

  getShowDeleteCreditCardModal() {
    return _showDeleteCreditCardModal;
  },

  getActiveWalletId() {
    return _activeWalletId;
  },

  getEmailPreferences() {
    return _emailPreferences;
  },

  getUnsubscribedAllEmails() {
    return _unsubscribedAllEmails;
  },

  hasPendingChanges() {
    return !_.isEmpty(_pendingChanges);
  },

  getPartnerBannerStatus(partnerId: $TSFixMe) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return _partnerBannerStatus[partnerId];
  },

  getTwoFactorAuthenticationStatus() {
    return _twoFactorAuthenticationStatus;
  },

  getTwoFactorAuthenticationQRCode() {
    return _twoFactorAuthenticationQRCode;
  },

  getTwoFactorAuthenticationInvalidFields() {
    return _twoFactorAuthenticationInvalidFields;
  },

  isTwoFactorAuthenticationUpdating() {
    return _twoFactorAuthenticationUpdating;
  },

  isTwoFactorAuthenticationSuccess() {
    return _twoFactorAuthenticationSuccess;
  },

  isAccountDeleted() {
    return _isAccountDeleted;
  },
});

// @ts-expect-error ts-migrate(2339) FIXME: Property 'dispatchToken' does not exist on type 'E... Remove this comment to see the full error message
SettingsStore.dispatchToken = SettingsDispatcher.register((payload) => {
  const { action } = payload;

  switch (action.type) {
    case Actions.SET_TOP_SECTION:
      _topSection = action.section;
      SettingsStore.emit('change');
      break;

    case Actions.HIDE_DELETE_CREDIT_CARD_MODAL:
      _showDeleteCreditCardModal = false;
      SettingsStore.emit('change');
      break;

    case Actions.SHOW_DELETE_CREDIT_CARD_MODAL:
      _showDeleteCreditCardModal = true;
      _activeWalletId = action.walletId;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_USER_SETTINGS:
      _user = action.userData;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_CREDIT_CARD_PREFERENCES:
      _creditCardPreferences = action.creditCardPreferences;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_PAYMENT_WALLETS:
      _wallets = action.wallets;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_EMAIL_PREFERENCES:
      _emailPreferences = action.emailPreferences;
      _notificationPreferences = action.notificationPreferences;
      SettingsStore.emit('change');
      break;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PARTNER_BANNER_STATUS_RECEIVED' does not... Remove this comment to see the full error message
    case Actions.PARTNER_BANNER_STATUS_RECEIVED:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _partnerBannerStatus[action.partnerId] = action.status;
      SettingsStore.emit('change');
      break;

    case Actions.RESET_SECTION:
      _updateStatus = {
        state: UpdateStates.IDLE,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      _invalidFields = [];
      _updatedEmailAddress = null;
      _unsubscribedAllEmails = null;
      SettingsStore.emit('change');
      break;

    case Actions.RESET_ALL_SECTIONS:
      _updateStatus = {
        state: UpdateStates.IDLE,
      };
      _invalidFields = [];
      _updatedEmailAddress = null;
      _unsubscribedAllEmails = null;
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_STARTED:
      _updateStatus = {
        state: UpdateStates.UPDATING,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_SUCCEEDED:
      _updateStatus = {
        state: UpdateStates.SUCCEEDED,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      _invalidFields = [];
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      delete _pendingChanges[action.section];
      SettingsStore.emit('change');
      break;

    case Actions.UPDATED_BASIC_INFORMATION:
      action.settings.forEach((setting: ProfileSetting) => {
        _user[setting.type] = setting.value;
      });
      break;

    case Actions.UPDATE_FIELD_FAILED:
      _invalidFields.push(action.field);
      break;

    case Actions.UPDATE_PASSWORD_FAILED_INSUFFICIENTLY_COMPLEX:
      _updateStatus = {
        state: UpdateStates.FAILED_NEW_PASSWORD_NOT_SUFFICIENTLY_COMPLEX,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_FAILED:
      _updateStatus = {
        state: UpdateStates.FAILED,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UPDATED_EMAIL_ADDRESS:
      _updatedEmailAddress = action.email;
      break;

    case Actions.UPDATE_FAILED_NAME_MALFORMED:
      _updateStatus = {
        state: UpdateStates.FAILED_NAME_MALFORMED,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_FAILED_EMAIL_IN_USE:
      _updateStatus = {
        state: UpdateStates.FAILED_EMAIL_IN_USE,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_FAILED_EMAIL_ADDRESS:
      _updateStatus = {
        state: UpdateStates.FAILED_EMAIL_ADDRESS,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ state: string; section: any; }' is not ass... Remove this comment to see the full error message
        section: action.section,
      };
      SettingsStore.emit('change');
      break;

    case Actions.UNSUBSCRIBED_ALL_EMAILS:
      _unsubscribedAllEmails = true;
      SettingsStore.emit('change');
      break;

    case Actions.UPDATE_PENDING_CHANGES_STATUS:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _pendingChanges[action.section] = action.isChanged;
      SettingsStore.emit('change');
      break;

    case Actions.LOADING_TWO_FACTOR_AUTHENTICATION_SETTINGS:
      _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.LOADING;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_TWO_FACTOR_AUTHENTICATION_SETTINGS:
      if (action.settings && action.settings.details.enabled === true) {
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.ENABLED;
      } else if (action.settings && action.settings.details.enabled === false) {
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.DISABLED;
      } else {
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.UNAVAILABLE;
      }
      SettingsStore.emit('change');
      break;

    case Actions.ENABLE_TWO_FACTOR_AUTHENTICATION:
      _twoFactorAuthenticationSuccess = false;
      _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_PASSWORD;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_TWO_FACTOR_AUTHENTICATION_QR_CODE:
      _twoFactorAuthenticationQRCode = action.qrCode;
      _twoFactorAuthenticationUpdating = false;
      _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_CODE;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_INVALID_PASSWORD:
      _twoFactorAuthenticationInvalidFields = ['password'];
      _twoFactorAuthenticationUpdating = false;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_TWO_FACTOR_AUTHENTICATION_CODE_CONFIRMATION_RESPONSE:
      if (action.success) {
        _twoFactorAuthenticationQRCode = null;
        _twoFactorAuthenticationUpdating = false;
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.ENABLED;
        // Separate boolean to avoid affecting old 2FA code. TODO: merge into status enum.
        _twoFactorAuthenticationSuccess = true;
      } else {
        _twoFactorAuthenticationInvalidFields = ['code'];
        _twoFactorAuthenticationUpdating = false;
      }
      SettingsStore.emit('change');
      break;

    case Actions.CANCEL_TWO_FACTOR_AUTHENTICATION_ACTION:
      if (
        _twoFactorAuthenticationStatus === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_PASSWORD ||
        _twoFactorAuthenticationStatus === TwoFactorAuthenticationStatus.ENABLING_CONFIRMING_CODE
      ) {
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.DISABLED;
        SettingsStore.emit('change');
      } else if (_twoFactorAuthenticationStatus === TwoFactorAuthenticationStatus.DISABLING_CONFIRMING_PASSWORD) {
        _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.ENABLED;
      }
      _twoFactorAuthenticationUpdating = false;
      _twoFactorAuthenticationInvalidFields = [];
      SettingsStore.emit('change');
      break;

    case Actions.PERFORMING_TWO_FACTOR_AUTHENTICATION_SERVER_ACTION:
      _twoFactorAuthenticationUpdating = true;
      _twoFactorAuthenticationInvalidFields = [];
      SettingsStore.emit('change');
      break;

    case Actions.DISABLE_TWO_FACTOR_AUTHENTICATION:
      _twoFactorAuthenticationSuccess = false;
      _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.DISABLING_CONFIRMING_PASSWORD;
      SettingsStore.emit('change');
      break;

    case Actions.RECEIVED_SUCCESSFUL_DISABLING_TWO_FACTOR_AUTHENTICATION_RESPONSE:
      _twoFactorAuthenticationStatus = TwoFactorAuthenticationStatus.DISABLED;
      _twoFactorAuthenticationUpdating = false;
      _twoFactorAuthenticationSuccess = true;
      SettingsStore.emit('change');
      break;

    case Actions.ACCOUNT_DELETED:
      _isAccountDeleted = true;
      SettingsStore.emit('change');
      break;

    default:
      break;
  }
});

export default SettingsStore;
